import { isAtOrOverLimit } from '@trello/business-logic/limit';
import { useBoardId } from '@trello/id-context';

import { useListComposerBoardListLimitsQuery } from './ListComposerBoardListLimitsQuery.generated';

export const useListComposerLimits = () => {
  const boardId = useBoardId();

  const { data } = useListComposerBoardListLimitsQuery({
    fetchPolicy: 'cache-only',
    variables: { boardId },
    waitOn: ['CurrentBoardInfo', 'CurrentBoardListsCards'],
  });

  const { openPerBoard, totalPerBoard } = data?.board?.limits?.lists ?? {};

  const hasTooManyOpenLists = isAtOrOverLimit(openPerBoard);
  const hasTooManyTotalLists = isAtOrOverLimit(totalPerBoard);

  const isListComposerDisabled = hasTooManyOpenLists || hasTooManyTotalLists;

  return {
    hasTooManyOpenLists,
    hasTooManyTotalLists,
    isListComposerDisabled,
  };
};
